import React from 'react'
import programsImg1 from "../images/programs/tuwe-post-education-copy.png"
import programsImg2 from "../images/programs/tuwe-services-ict-copy.jpg"
import programsImg3 from "../images/programs/economic.png"
import programsImg4 from "../images/programs/tuwe-highschool-support-copy.png"
import { useEffect } from 'react'
import { useRef } from 'react'

const Programs = () => {

  const servicesRef = useRef(null);
  
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <>
    {/* Features Section */}
<section id="programs" className="features section" ref={servicesRef}>
  <div className="container">
      <div className="container section-title programs-title" data-aos="fade-up">
    <h2 data-reveal>Programs</h2>
    <p data-reveal>Learning, Skills And Opportunity.</p>
  </div>

    <ul
      className="nav nav-tabs row d-flex"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <li className="nav-item col-3" data-reveal>
        <a
          className="nav-link active show"
          data-bs-toggle="tab"
          data-bs-target="#features-tab-1"
        >
          <i className="bi bi-binoculars"></i>
          <h4 className="d-none d-lg-block">
            1.Post secondary school Education advancement.
          </h4>
        </a>
      </li>

      <li className="nav-item col-3" data-reveal>
        <a
          className="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#features-tab-2"
        >
          <i className="bi bi-box-seam"></i>
          <h4 className="d-none d-lg-block">
            2.Digital Literacy and ICT Training
          </h4>
        </a>
      </li>

      <li className="nav-item col-3" data-reveal>
        <a
          className="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#features-tab-3"
        >
          <i className="bi bi-brightness-high"></i>
          <h4 className="d-none d-lg-block">
            3.Supporting needy youths through high school
          </h4>
        </a>
      </li>

      <li className="nav-item col-3" data-reveal>
        <a
          className="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#features-tab-4"
        >
          <i className="bi bi-command"></i>
          <h4 className="d-none d-lg-block">
            4.Economic Empowerment
          </h4>
        </a>
      </li>
    </ul>
    {/* End Tab Nav */}

    <div
      className="tab-content"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <div className="tab-pane fade active show" id="features-tab-1">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h3 data-reveal>Post secondary school Education advancement.</h3>
            <p className=" " data-reveal>
            Tuwe Initiative exists to make post-secondary education possible for the “underserved
            majority” capable young people, especially young women, who completed high school
            but were locked out of university and scholarships by low grades, poverty, distance, or
            care responsibilities. 
              <br />
              <br />
            Through our ICT Resource Hubs, Tuwe provides a stable, equipped
            learning environment with reliable internet and power, structured study support, and a
            practical bridge to accredited colleges and universities delivering online and blended
            programmes. In doing so, we advance our mission as a last-mile education delivery
            programme that restores access and dignity to learners who would otherwise be
            excluded.

       </p>
          </div>

          <div className="col-lg-6 order-1 order-lg-2 text-center" data-reveal>
            <img
              src={programsImg1}
              alt=""
              className=" "
            />
          </div>
        </div>
      </div>
      {/* End Tab Content Item */}

      <div className="tab-pane fade" id="features-tab-2">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h3 data-reveal>Digital Literacy and ICT Training</h3>
            <p className=" " data-reveal>
             Digital access without digital capability deepens inequality. Tuwe’s Digital Literacy and
              ICT Training programme equips learners with the practical skills needed to participate in
              today’s digital economy. With the world moving into more digital space and digital
              economy and e-commerce providing immense opportunities, Tuwe Initiative ensures
              that these young women can effectively and with the agency and skills required, can
              participate and begin to earn income.
              <br />
              <br />
              Delivered through our hubs, the training is hands-on, contextual, and designed for low-
              income learners who have had limited exposure to devices, ensuring that digital skills
              become a gateway rather than a barrier.
              <br />
              <br />
              This advances our mission by coupling access with empowerment, ensuring technology
              translates into practical skills, increased confidence, and measurable educational and
              economic outcomes.
            </p>
          </div>

          <div className="col-lg-6 order-1 order-lg-2 text-center" data-reveal>
            <img
              src={programsImg2}
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* End Tab Content Item */}

      <div className="tab-pane fade" id="features-tab-3">
        <div className="row">
          <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h3 data-reveal>Supporting needy youths through high school</h3>
           <p className=" " data-reveal>
              For many families, a single crisis can pull a learner out of school: a parent loses work,
              rent falls behind, food becomes scarce, or a girl is expected to stay home and help.
              When that happens, education is often the first thing sacrificed especially for first
              generation learners and returning is harder. 
              <br />
              <br />
              Tuwe’s High School Support programme is designed to stop that silent loss. We identify high-need learners with strong potential
              and mobilize targeted support to keep them in school, learning, and believing in a future
              worth working for. Alongside practical assistance, we provide mentorship and guidance
              that helps young people set goals, stay motivated, and navigate the transition to post-
              secondary opportunities.   </p>
          </div>

          <div className="col-lg-6 order-1 order-lg-2 text-center" data-reveal>
            <img
              src={programsImg4}
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* End Tab Content Item */}

      <div className="tab-pane fade" id="features-tab-4">
        <div className="row">
<div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
  <h3 data-reveal>Economic Empowerment</h3>
  <p data-reveal>
    Education should not end with a certificate and nowhere to go. Many young people
    finish training still facing the same harsh reality: no job networks, no capital, and few
    safe options to earn an income. Tuwe’s Economic Empowerment programme helps
    learners turn skills into stability.
    <br />
    <br />
    Through coaching, career readiness support, and
    practical enterprise guidance, we prepare youth for work and support them to start or
    strengthen small income-generating activities often using digital channels to reach
    customers and opportunities. This aligns with our mission because true empowerment
    is not only access to learning, but the ability to use that learning to build agency, a safer
    and more independent life.  
    In doing so, we bridge the gap between education and real livelihoods for young people.
    <br />
    <br />
     
  </p>
</div>


          <div className="col-lg-6 order-1 order-lg-2 text-center" data-reveal>
            <img
              src={programsImg3}
              alt=""
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* End Tab Content Item */}
    </div>
  </div>
</section>
{/* /Features Section */}

    </>
  )
}

export default Programs